var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRechargeIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    width: "100%",
    height: "100%",
    overflow: "visible",
    style: {
      display: "block"
    },
    viewBox: "0 0 12 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\xE5\x85\x85\xE5\x80\xBC 1",
    clipPath: "url(#clip0_831_1189)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union",
    d: "M11.3379 4.02863C11.6448 4.02885 11.9062 4.27959 11.9062 4.59796V6.79327H9.09668V6.25812C9.09648 5.97389 8.7665 5.81508 8.53906 5.98566L5.91113 8.04425C5.74065 8.18079 5.74055 8.44294 5.91113 8.57941L8.52734 10.638C8.75485 10.8086 9.08496 10.6489 9.08496 10.3646V9.83038H11.9062V12.0257C11.9062 12.3327 11.6562 12.5938 11.3379 12.5941H0.568359C0.261401 12.5938 0 12.3441 0 12.0257V4.59796C0 4.29096 0.250044 4.02885 0.568359 4.02863H11.3379ZM9.15723 0.519836C9.44157 0.428919 9.73713 0.588663 9.82812 0.861633L10.5225 3.00031L1.25098 3.07941L9.15723 0.519836Z",
    fill: "var(--fill-0, white)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M7.96094 6.52344C8.39571 6.17696 8.94851 6.44803 9.07031 6.89551H11.4971C11.8242 6.89574 12.2161 7.15714 12.2012 7.60059V9.03418C12.2011 9.42384 11.8867 9.73805 11.4971 9.73828H9.07227C8.95222 10.2186 8.36397 10.4148 7.96582 10.1162L7.95898 10.1113L6.36621 8.87109L6.35352 8.86133L6.34082 8.85059C6.03083 8.57492 5.99065 8.0442 6.36621 7.75195L6.36816 7.75098L7.96094 6.52246V6.52344Z",
    fill: "var(--fill-0, white)",
    stroke: "var(--stroke-0, #FF7F36)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_831_1189"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 13,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRechargeIcon);
export default __webpack_public_path__ + "static/media/rechargeIcon.430aa2dfee06d69b7a8144b4f6c70c98.svg";
export { ForwardRef as ReactComponent };